'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createChart = exports.Config = exports.Store = undefined;

require('core-js/fn/array/find-index');

var _store = require('./store');

var _store2 = _interopRequireDefault(_store);

var _config = require('./config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultError = function defaultError(error) {
    throw new Error(error);
};

var defaultWarning = function defaultWarning(warning) {
    console.log(warning);
};

function createChart(data, layout, el, extraOptions) {
    var error = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : defaultError;
    var warning = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : defaultWarning;

    var store = new _store2.default({ data: data, error: error, warning: warning });
    var config = new _config2.default({ store: store, layout: layout, el: el, extraOptions: extraOptions, error: error, warning: warning });

    return {
        store: store,
        config: config,
        chart: config.createChart()
    };
}

exports.Store = _store2.default;
exports.Config = _config2.default;
exports.createChart = createChart;
exports.default = {
    Store: _store2.default,
    Config: _config2.default,
    createChart: createChart
};
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/index.js
 ** module id = 77
 ** module chunks = 0 1
 **/